module.exports = __webpack_public_path__ + "img/pherrol6.74637b37.jpg";